import { render, staticRenderFns } from "./CreateBrewery.vue?vue&type=template&id=2c5634b0&"
import script from "./CreateBrewery.vue?vue&type=script&lang=ts&"
export * from "./CreateBrewery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreateBrewery.vue"
export default component.exports